import { useI18n } from "@/context/I18nContext";
import { LayoutGrid, Tags } from "lucide-react";
import { PosCard, RankTable } from "./PosTable";
import { OPS } from "@/constants/testIds";

const PI = OPS.posInsights;

export default function PosCategoriesPanel({ data }) {
    const { t, lang } = useI18n();
    const nameOf = (r) => (lang === "ar" ? r.name_ar || r.name_en : r.name_en || r.name_ar);
    const cols = [
        { key: "name", label: t("pi_col_category"), strong: true },
        { key: "qty", label: t("pi_col_qty"), type: "num1" },
        { key: "revenue", label: t("pi_col_revenue"), type: "num" },
    ];
    const prep = (rows) => (rows || []).map((r) => ({ ...r, name: nameOf(r) }));

    return (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            <PosCard icon={LayoutGrid} title={t("pi_menu_cats")} desc={t("pi_items_desc")}>
                <RankTable testId={PI.catsMenu} dataset="pos_category_daily" rows={prep(data?.menu_categories)} columns={cols} shareKey="revenue"
                    rowTestId={(r, i) => `pos-insights-menu-cat-${r.id ?? i}`} />
            </PosCard>
            <PosCard icon={Tags} title={t("pi_recipe_cats")} desc={t("pi_items_desc")}>
                <RankTable testId={PI.catsRecipe} dataset="pos_category_daily" rows={prep(data?.recipe_categories)} columns={cols} shareKey="revenue"
                    rowTestId={(r, i) => `pos-insights-recipe-cat-${r.id ?? i}`} />
            </PosCard>
        </div>
    );
}
